import React from 'react';
import { Button } from '@material-ui/core';
import { toJS } from 'mobx';
import { useRootStore } from '../../../../stores/BridgeProvider';
import { safeEval } from '../../../util/UtilFunctions';
import VoucherForm from '../../../vouchers/VoucherForm';

const VoucherModal = ({ voucherId, handleClose }) => {
  const { dealMapperStore, orgStore } = useRootStore();
  const voucher = voucherId ? dealMapperStore.voucher(voucherId) : {};
  console.log(toJS(voucher));
  const { Pending } = voucher;
  const type = safeEval(() => orgStore.settings.VoucherTypeDefault);
  return (
    <VoucherForm
      type={type}
      submitLabel="Submit"
      buttons={[
        <Button
          color="secondary"
          variant="outlined"
          size="large"
          style={{
            margin: '5px',
          }}
          onClick={() => handleClose()}
        >
          Cancel
        </Button>,
      ]}
      onSubmit={values => {
        const {
          VoucherId,
          VoucherTypeId,
          VoucherNumber,
          Description,
          VoucherDate,
          Amount,
          ContactId,
          DueDate,
          StatusId,
          AccountId,
          Seed,
          Persisted,
        } = values;
        if (voucherId) {
          dealMapperStore.updateVoucher({
            ...voucher,
            VoucherId,
            VoucherTypeId,
            VoucherNumber,
            Description,
            VoucherDate,
            Amount,
            ContactId,
            DueDate,
            StatusId,
            AccountId,
          });
        } else {
          dealMapperStore.createVoucher({
            VoucherId,
            VoucherTypeId,
            VoucherNumber,
            Description,
            VoucherDate,
            Amount,
            ContactId,
            DueDate,
            StatusId,
            AccountId,
          });
        }

        handleClose();
      }}
      voucher={voucher}
    />
  );
};

export default VoucherModal;
